import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { SiteShell } from "@/SiteShell";
import Home from "@/app/page";
const AboutPage = lazy(() => import("@/app/about/page"));
const ContactPage = lazy(() => import("@/app/contact/page"));
const BookPage = lazy(() => import("@/app/book/page"));
const UsMarketPage = lazy(() => import("@/app/us/page"));
const UkMarketPage = lazy(() => import("@/app/uk/page"));
const AuMarketPage = lazy(() => import("@/app/au/page"));
const UaeMarketPage = lazy(() => import("@/app/uae/page"));
const TermsPage = lazy(() => import("@/app/terms/page"));
const PrivacyPage = lazy(() => import("@/app/privacy/page"));
const CollabPage = lazy(() => import("@/app/collab/page"));
const ScanPage = lazy(() => import("@/app/scan/page"));
const ClinicsPage = lazy(() => import("@/app/clinics/page"));
const BlueprintPage = lazy(() => import("@/app/blueprint/page"));
const DeckPage = lazy(() => import("@/app/deck/page"));
const ReignConferencePage = lazy(() => import("@/app/reign-conference/page"));
const ServicesPage = lazy(() => import("@/app/services/page"));
const StrategyConsultingPage = lazy(() => import("@/app/services/strategy-consulting/page"));
const BrandingDesignPage = lazy(() => import("@/app/services/branding-design/page"));
const DigitalMarketingPage = lazy(() => import("@/app/services/digital-marketing/page"));
const WebDevelopmentPage = lazy(() => import("@/app/services/web-development/page"));
const MobileAppDevelopmentPage = lazy(() => import("@/app/services/mobile-app-development/page"));
const AiSolutionsPage = lazy(() => import("@/app/services/ai-solutions/page"));
const ContentCreationPage = lazy(() => import("@/app/services/content-creation/page"));
const EcommerceSolutionsPage = lazy(() => import("@/app/services/ecommerce-solutions/page"));
const SolutionsHubPage = lazy(() => import("@/app/solutions/page"));
const SolutionDetailPage = lazy(() => import("@/app/solutions/[slug]/page"));
const BlogIndexPage = lazy(() => import("@/app/blog/page"));
const BlogPostPage = lazy(() => import("@/app/blog/[slug]/page"));
const BlogCategoryPage = lazy(() => import("@/app/blog/category/[slug]/page"));
const BlogTagPage = lazy(() => import("@/app/blog/tag/[slug]/page"));
const GuidesIndexPage = lazy(() => import("@/app/guides/page"));
const GuidePostPage = lazy(() => import("@/app/guides/[slug]/page"));
const GuideCategoryPage = lazy(() => import("@/app/guides/category/[slug]/page"));
const ResourcesIndexPage = lazy(() => import("@/app/resources/page"));
const ResourcePostPage = lazy(() => import("@/app/resources/[slug]/page"));
const ResourceCategoryPage = lazy(() => import("@/app/resources/category/[slug]/page"));
const PortfolioIndexPage = lazy(() => import("@/app/portfolio/page"));
const PortfolioCaseStudyPage = lazy(() => import("@/app/portfolio/[slug]/page"));
const PortfolioCategoryPage = lazy(() => import("@/app/portfolio/category/[slug]/page"));
const PortfolioIndustryPage = lazy(() => import("@/app/portfolio/industry/[slug]/page"));
const PortfolioCompanyPage = lazy(() => import("@/app/portfolio/company/[slug]/page"));
const AdminLayout = lazy(() => import("@/app/admin/layout"));
const AdminDashboardPage = lazy(() => import("@/app/admin/page"));
const AdminPortfolioPage = lazy(() => import("@/app/admin/portfolio/page"));
const AdminPortfolioProjectPage = lazy(() => import("@/app/admin/portfolio/[projectSlug]/page"));
const AdminCategoriesPage = lazy(() => import("@/app/admin/categories/page"));
const AdminIndustriesPage = lazy(() => import("@/app/admin/industries/page"));
const AdminSettingsPage = lazy(() => import("@/app/admin/settings/page"));
const NotFound = lazy(() => import("@/app/not-found"));

function PageFallback() {
  return <div className="min-h-dvh bg-[#050505]" aria-hidden />;
}

export default function App() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        <Route element={<SiteShell />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/book" element={<BookPage />} />
          <Route path="/us" element={<UsMarketPage />} />
          <Route path="/uk" element={<UkMarketPage />} />
          <Route path="/au" element={<AuMarketPage />} />
          <Route path="/uae" element={<UaeMarketPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/collab" element={<CollabPage />} />
          <Route path="/scan" element={<ScanPage />} />
          <Route path="/clinics" element={<ClinicsPage />} />
          <Route path="/blueprint" element={<BlueprintPage />} />
          <Route path="/deck" element={<DeckPage />} />
          <Route path="/deck/:niche" element={<DeckPage />} />
          <Route path="/reign-conference" element={<ReignConferencePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/strategy-consulting" element={<StrategyConsultingPage />} />
          <Route path="/services/branding-design" element={<BrandingDesignPage />} />
          <Route path="/services/digital-marketing" element={<DigitalMarketingPage />} />
          <Route path="/services/web-development" element={<WebDevelopmentPage />} />
          <Route path="/services/mobile-app-development" element={<MobileAppDevelopmentPage />} />
          <Route path="/services/ai-solutions" element={<AiSolutionsPage />} />
          <Route path="/services/content-creation" element={<ContentCreationPage />} />
          <Route path="/services/ecommerce-solutions" element={<EcommerceSolutionsPage />} />
          <Route path="/solutions" element={<SolutionsHubPage />} />
          <Route path="/solutions/:slug" element={<SolutionDetailPage />} />
          <Route path="/blog" element={<BlogIndexPage />} />
          <Route path="/blog/category/:slug" element={<BlogCategoryPage />} />
          <Route path="/blog/tag/:slug" element={<BlogTagPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/guides" element={<GuidesIndexPage />} />
          <Route path="/guides/category/:slug" element={<GuideCategoryPage />} />
          <Route path="/guides/:slug" element={<GuidePostPage />} />
          <Route path="/resources" element={<ResourcesIndexPage />} />
          <Route path="/resources/category/:slug" element={<ResourceCategoryPage />} />
          <Route path="/resources/:slug" element={<ResourcePostPage />} />
          <Route path="/portfolio" element={<PortfolioIndexPage />} />
          <Route path="/portfolio/category/:slug" element={<PortfolioCategoryPage />} />
          <Route path="/portfolio/industry/:slug" element={<PortfolioIndustryPage />} />
          <Route path="/portfolio/company/:slug" element={<PortfolioCompanyPage />} />
          <Route path="/portfolio/:slug" element={<PortfolioCaseStudyPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboardPage />} />
            <Route path="portfolio" element={<AdminPortfolioPage />} />
            <Route path="portfolio/:projectSlug" element={<AdminPortfolioProjectPage />} />
            <Route path="categories" element={<AdminCategoriesPage />} />
            <Route path="industries" element={<AdminIndustriesPage />} />
            <Route path="settings" element={<AdminSettingsPage />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
